import { UseLoadingReturn } from "@/hooks/use-loading";
import useRemove from "@/hooks/use-remove";
import productVariationService from "@/services/variation.service";
import { RemoveByIdProps } from "@/types/requests.types";

export type UseRemoveProductVariationReturn = {
  remove: (props: RemoveByIdProps) => Promise<void>;
} & UseLoadingReturn;

const useRemoveProductVariation = (): UseRemoveProductVariationReturn => {
  const { isLoading, startLoading, endLoading, loadingIcon, remove } = useRemove({
    operation: (variationId) => productVariationService.delete(variationId),
  });

  return {
    isLoading,
    startLoading,
    endLoading,
    loadingIcon,
    remove,
  };
};

export default useRemoveProductVariation;
